import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { event } from 'jquery';
import { base64ToFile, ImageCroppedEvent } from 'ngx-image-cropper';
import { Observable } from 'rxjs';
import { OnboardingService } from '../../onboarding.service';
import { Router } from '@angular/router';
import { min } from 'moment-timezone';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-setup1',
  templateUrl: './setup1.component.html',
  styleUrls: ['./setup1.component.css']
})
export class Setup1Component implements OnInit {
  imgChangeEvt: any = '';
  cropImgPreview: any = '';
  userId: any;
  text: any;
  croppedImage: any;
  stopCropper: boolean = true;
  imageBoxDisable: boolean;
  imageFlag: boolean = false;
  iconDisabled: boolean = true;
  cropButton: boolean = false;
  imageText: any;
  // originalFile: any;
  files: File;
  imgFile: File;
  finalImage: any;
  originalFile: any;
  cropImgButton: boolean = true;
  clickedCrop: boolean = false;


  submitButtonEnabled: boolean = false;
  userType: any;
  list: any;
  userProfile: any;
  constructor(private OnboardingService: OnboardingService, private http: HttpClient,private route: ActivatedRoute,
    private _sanitizer: DomSanitizer, private Router: Router) 
    {this.userId = route.snapshot.params.id; }
  ngOnInit(): void {
    this.OnboardingService.getUserProfile(this.userId).subscribe((res) => {
      this.userProfile = res;
      if(this.userProfile.profilePic){
        this.cropImgPreview=this.userProfile.profilePic;
        this.imageBoxDisable=false;
        this.submitButtonEnabled=true;
this.croppedImage= this.cropImgPreview;
      }
      else  if(!this.userProfile.profilePic){
        this.imageBoxDisable=true;
        this.submitButtonEnabled=false;

      }
      if(this.userProfile.updateMyWords){
        this.imageText=this.userProfile.updateMyWords;
      }
    })
  }

  onFileChange(event: any): void {
    this.imgChangeEvt = event;
    console.log(event)

    this.stopCropper = true;
    this.imageFlag = true;
    this.iconDisabled = false;
    if(!this.cropImgPreview){
      this.clickedCrop=true;
    }
    this.clickedCrop = false;

    this.originalFile = event.target.files[0];
    console.log(this.originalFile)

    if (event.target.files[0].size >= 41943040) {
      console.log(event.target.files[0].size)

      alert("File size is too big")
      this.imageFlag = false;
      this.imgChangeEvt = '';
      this.iconDisabled = true;
      this.clickedCrop = true;
    }
    if(this.originalFile.type !== "image/png" &&
    this.originalFile.type !== "image/jpg" &&
    this.originalFile.type !== "image/jpeg"
     ){
      this.imageFlag = false;
      this.imgChangeEvt = '';
      this.iconDisabled = true;
      this.clickedCrop = true;
      alert("File type must be png, jpg, jpeg")
    }
    
  }
  click() {
    if(!this.cropImgPreview){
      this.clickedCrop=true;
    }
    this.stopCropper = true;
    this.cropButton = true;
  }
  
  imageCropped(event: ImageCroppedEvent,file: any) {

      this.cropImgPreview = event.base64;  
this.croppedImage=this.cropImgPreview;

   }

  imgLoad() {
      // display cropper tool
  }
  initCropper() {
      // init cropper
  }

  imgFailed() {
      // error msg
  }
  cropImage(file:any){
this.cropImgButton=false;
    this.stopCropper=false;  
    this.imageBoxDisable=false
    this.cropButton=false;
    this.submitButtonEnabled=true;
    this.croppedImage=  base64ToFile(this.croppedImage);
    this.finalImage= URL.createObjectURL(this.croppedImage);
    let mysrc;
    const reader = new FileReader();
    reader.readAsDataURL(this.croppedImage); 
    reader.onloadend = function() {
       mysrc = reader.result;     
    }
    mysrc=this.croppedImage
    
     console.log(this.croppedImage)
  
  }
  
  submitData(image:any,text:any){
    const data = this.OnboardingService.postSetup1(this.userId,this.imageText,this.croppedImage).subscribe();
    console.log(data)
    this.Router.navigate([`/userProfiles/${this.userId}/setup/2`]);

     return data;

}





}
